import type { Locale } from '../site'

export type Dict = Record<string, string>

const zhCN: Dict = {
  brand: '屏幕鸟',
  nav_home: '首页',
  nav_inspect: '分步清单',
  nav_quality: '画面质检',
  nav_motion: '动态',
  nav_touch: '触控',
  nav_lab: '实验室',
  nav_report: '报告',
  nav_settings: '设置',
  nav_more: '更多',
  nav_content: '知识中心',
  nav_qa: '问答中心',
  nav_articles: '选购指南',
  solid: '坏点 / 纯色',
  gradient: '色阶 / 渐变',
  grid: '网格 / 几何',
  uniformity: '漏光 / 均匀性',
  anti_burn_in: '防烧屏 / 像素刷新',
  refresh: '刷新率实测',
  motion_tool: '拖影 / 运动',
  touch_tool: '多点触控',
  media_lab: '媒体查询',
  safe_area: '安全区',
  start_test: '开始检测',
  exit: '退出',
  fullscreen: '进入全屏',
  prev: '上一项',
  next: '下一项',
  mark: '标记',
  hide_hud: '隐藏控件',
  hidden_hint_exit: '按 Esc 退出全屏',
  hidden_hint_next: ' · 点击画面进入下一步',
  hidden_hint_fullscreen: ' · 点击下方按钮进入全屏',
  copy: '复制摘要',
  theme: '主题',
  language: '语言',
  follow_system: '跟随系统',
  light: '浅色',
  dark: '深色',
  system: '系统',
  estimated: '估算',
  unsupported: '不支持',
  home_title: '屏幕鸟',
  home_lead: '检查屏幕有没有坏点、漏光、触控失灵。点一次就能开始，数据只留在你设备里。',
  home_cta_hint: '先从最常用的坏点检测开始，全屏看黑白红绿蓝',
  home_more: '更多检测（可选）',
  path_dead_title: '查坏点',
  path_dead_desc: '全屏纯色，一眼看出亮点、暗点',
  path_bleed_title: '查漏光',
  path_bleed_desc: '黑屏看边角发白、亮度不均',
  path_touch_title: '查触控',
  path_touch_desc: '多指按下，检查有没有失灵',
  metric_css: 'CSS 分辨率',
  metric_phys: '物理像素（估算）',
  metric_dpr: '设备像素比',
  metric_viewport: '视口',
  metric_ratio: '宽高比',
  section_screen: '屏幕与像素',
  section_prefs: '系统偏好',
  section_tools: '常用检测',
  faq_title: '常见问题',
  qa_view_all: '查看全部问答',
  qa_dead_home: '发现坏点后应该怎么办？',
  qa_bleed_home: '屏幕边缘发白算漏光吗？',
  qa_refresh_home: '为什么刷新率测试结果会波动？',
  privacy_note: '纯前端运行，不上传屏幕数据',
  updated: '更新',
  tool_eyebrow: '工具',
  footer_note: '屏幕鸟 · 纯浏览器本地 · 不上传',
  clear_marks: '清除标记',
  solid_lead: '切换全屏纯色检查亮点、暗点与色斑。按 M 进入标记模式，点击留下坐标；Esc 退出。',
  solid_body: '适合购机自检与售后复现。物理像素级缺陷需肉眼确认；标记坐标基于 CSS 像素。',
  solid_shortcuts: '快捷键：← → 切换颜色 · M 标记 · H 隐藏控件 · Esc 退出',
  solid_faq1_q: '如何检测坏点？',
  solid_faq1_a: '进入全屏后在黑白红绿蓝背景上观察，发现异常点按 M 标记。',
  solid_faq2_q: '怎么标记坏点？',
  solid_faq2_a: '按 M 开启标记模式，再点缺陷位置。坐标列在下方，只保存在本地。',
  gradient_lead: '用水平、垂直灰度与 RGB 通道渐变观察色阶断层；阶梯模式便于逐级对比。',
  gradient_body: '低位深面板或过度压缩时常见色带。本测试在浏览器里绘制渐变。',
  grid_lead: '全屏网格与棋盘格，用于观察扭曲、模糊与像素对齐问题。',
  grid_body: '细网格更容易看出缩放模糊和整屏清晰度不均。',
  grid_size: '网格大小',
  uniformity_lead: '在暗室或弱光环境观察全黑场四角漏光，再用灰阶色块比较均匀性。',
  uniformity_body: '建议在暗一点的环境看。IPS 屏四角微光较常见，严重程度因人而异。',
  anti_burn_in_lead: '全屏动态图案锻炼像素，降低长时间固定界面造成的不均匀老化风险。不能修复已形成的烧屏。',
  anti_burn_in_body: '适合 OLED / AMOLED 闲置时运行。建议中低亮度、插电使用；离开前确认息屏或退出。这不是维修工具。',
  anti_burn_in_pattern: '图案',
  anti_burn_in_noise: '噪点刷新',
  anti_burn_in_stripe: '色带扫过',
  anti_burn_in_orbit: '光斑游走',
  anti_burn_in_pulse: '柔和色循环',
  anti_burn_in_speed: '速度',
  anti_burn_in_duration: '时长',
  anti_burn_in_manual: '手动退出',
  anti_burn_in_start: '开启防烧屏',
  anti_burn_in_learn: '了解烧屏',
  anti_burn_in_tip: '快捷键：← → 切换图案 · H 隐藏控件 · Esc 退出。运行中可保持唤醒；结束请手动退出或等待倒计时。',
  refresh_lead: '采样动画帧间隔估算 Hz。结果受浏览器限帧与省电影响，属于估算值。',
  refresh_avg: '平均 Hz',
  refresh_low: '1% 低帧 Hz',
  refresh_frames: '采样帧数',
  refresh_measure: '测 5 秒',
  refresh_note: '这是估算值，不能替代示波器等仪器。',
  motion_lead: '全屏移动色条，调节速度观察拖影与清晰度。',
  motion_speed: '速度',
  touch_lead: '同时按下多个触点，查看编号、坐标与力（若设备支持）。',
  touch_body: '请在触控屏上使用。每个触点会显示编号，抬起后轨迹逐渐消失。',
  touch_active: '当前触点',
  touch_max: '历史最多',
  media_lead: '面向前端的实时 matchMedia 面板，复制当前为真的查询集合。',
  media_copy: '复制为真的查询',
  safe_lead: '叠加显示 env(safe-area-inset-*)，方便调试全面屏边距。',
  safe_top: '上',
  safe_right: '右',
  safe_bottom: '下',
  safe_left: '左',
  safe_overlay: '显示叠加',
  inspect_lead: '可选：按项勾选常用检测。日常使用直接点首页「开始检测」即可。',
  inspect_step1: '1. 信息快检',
  inspect_step2: '2. 坏点纯色',
  inspect_step3: '3. 漏光均匀性',
  inspect_step4: '4. 触控检查',
  inspect_pass: '标记通过',
  inspect_fail: '标记失败',
  inspect_open_solid: '打开坏点检测',
  inspect_open_report: '打开报告',
  status_todo: '待测',
  status_pass: '通过',
  status_fail: '失败',
  report_lead: '汇总当前显示指标，复制或下载 JSON。历史仅存浏览器本地。',
  report_generating: '生成中…',
  report_copy: '复制',
  report_download: '下载 JSON',
  settings_lead: '界面语言默认跟随设备；也可锁定语言与主题。数据仅存本机。',
  settings_clear: '清除本地数据',
  settings_clear_note: '将清除语言、主题与草稿报告等本地偏好。',
  faq_how_q: '怎么用？',
  faq_how_a: '点「开始检测」→ 进入全屏 → 切换颜色看屏幕。发现异常可标记。Esc 或点退出返回。',
  faq_upload_q: '会不会上传我的屏幕信息？',
  faq_upload_a: '不会。全部在浏览器本地完成，不上传。',
  faq_checklist_q: '「分步清单」是干什么的？',
  faq_checklist_a: '给想一项项勾选的人用的可选清单，日常使用直接点「开始检测」就够了。',
  marks_label: '标记',
  touches_label: '触点',
}

const zhTW: Dict = {
  brand: '屏幕鳥',
  nav_home: '首頁',
  nav_inspect: '分步清單',
  nav_quality: '畫面質檢',
  nav_motion: '動態',
  nav_touch: '觸控',
  nav_lab: '實驗室',
  nav_report: '報告',
  nav_settings: '設定',
  nav_more: '更多',
  nav_content: '知識中心',
  nav_qa: '問答中心',
  nav_articles: '選購指南',
  solid: '壞點 / 純色',
  gradient: '色階 / 漸變',
  grid: '網格 / 幾何',
  uniformity: '漏光 / 均勻性',
  anti_burn_in: '防燒屏 / 像素刷新',
  refresh: '刷新率實測',
  motion_tool: '殘影 / 運動',
  touch_tool: '多點觸控',
  media_lab: '媒體查詢',
  safe_area: '安全區',
  start_test: '開始檢測',
  exit: '退出',
  fullscreen: '進入全屏',
  prev: '上一項',
  next: '下一項',
  mark: '標記',
  hide_hud: '隱藏控件',
  hidden_hint_exit: '按 Esc 退出全螢幕',
  hidden_hint_next: ' · 點擊畫面進入下一步',
  hidden_hint_fullscreen: ' · 點擊下方按鈕進入全螢幕',
  copy: '複製摘要',
  theme: '主題',
  language: '語言',
  follow_system: '跟隨系統',
  light: '淺色',
  dark: '深色',
  system: '系統',
  estimated: '估算',
  unsupported: '不支援',
  home_title: '屏幕鳥',
  home_lead: '檢查螢幕有沒有壞點、漏光、觸控失靈。點一次就能開始，資料只留在你設備裡。',
  home_cta_hint: '先從最常用的壞點檢測開始，全螢幕看黑白紅綠藍',
  home_more: '更多檢測（可選）',
  path_dead_title: '查壞點',
  path_dead_desc: '全螢幕純色，一眼看出亮點、暗點',
  path_bleed_title: '查漏光',
  path_bleed_desc: '黑屏看邊角發白、亮度不均',
  path_touch_title: '查觸控',
  path_touch_desc: '多指按下，檢查有沒有失靈',
  metric_css: 'CSS 解析度',
  metric_phys: '實體像素（估算）',
  metric_dpr: '裝置像素比',
  metric_viewport: '視口',
  metric_ratio: '寬高比',
  section_screen: '螢幕與像素',
  section_prefs: '系統偏好',
  section_tools: '常用檢測',
  faq_title: '常見問題',
  qa_view_all: '查看全部問答',
  qa_dead_home: '發現壞點後應該怎麼辦？',
  qa_bleed_home: '螢幕邊緣發白算漏光嗎？',
  qa_refresh_home: '為什麼更新率測試結果會波動？',
  privacy_note: '純前端執行，不上傳螢幕資料',
  updated: '更新',
  tool_eyebrow: '工具',
  footer_note: '屏幕鳥 · 純瀏覽器本地 · 不上傳',
  clear_marks: '清除標記',
  solid_lead: '切換全螢幕純色檢查亮點、暗點與色斑。按 M 進入標記模式，點擊留下座標；Esc 退出。',
  solid_body: '適合購機自檢與售後復現。物理像素級缺陷需肉眼確認；標記座標基於 CSS 像素。',
  solid_shortcuts: '快捷鍵：← → 切換顏色 · M 標記 · H 隱藏控件 · Esc 退出',
  solid_faq1_q: '如何檢測壞點？',
  solid_faq1_a: '進入全螢幕後在黑白紅綠藍背景上觀察，發現異常點按 M 標記。',
  solid_faq2_q: '怎麼標記壞點？',
  solid_faq2_a: '按 M 開啟標記模式，再點缺陷位置。座標列在下方，只保存在本地。',
  gradient_lead: '用水平、垂直灰階與 RGB 通道漸變觀察色階斷層；階梯模式便於逐級對比。',
  gradient_body: '低位深面板或過度壓縮時常見色帶。本測試在瀏覽器裡繪製漸變。',
  grid_lead: '全螢幕網格與棋盤格，用於觀察扭曲、模糊與像素對齊問題。',
  grid_body: '細網格更容易看出縮放模糊和整屏清晰度不均。',
  grid_size: '網格大小',
  uniformity_lead: '在暗室或弱光環境觀察全黑場四角漏光，再用灰階色塊比較均勻性。',
  uniformity_body: '建議在暗一點的環境看。IPS 屏四角微光較常見，嚴重程度因人而異。',
  anti_burn_in_lead: '全螢幕動態圖案鍛鍊像素，降低長時間固定介面造成的不均勻老化風險。不能修復已形成的燒屏。',
  anti_burn_in_body: '適合 OLED / AMOLED 閒置時運行。建議中低亮度、插電使用；離開前確認熄屏或退出。這不是維修工具。',
  anti_burn_in_pattern: '圖案',
  anti_burn_in_noise: '噪點刷新',
  anti_burn_in_stripe: '色帶掃過',
  anti_burn_in_orbit: '光斑遊走',
  anti_burn_in_pulse: '柔和色循環',
  anti_burn_in_speed: '速度',
  anti_burn_in_duration: '時長',
  anti_burn_in_manual: '手動退出',
  anti_burn_in_start: '開啟防燒屏',
  anti_burn_in_learn: '了解燒屏',
  anti_burn_in_tip: '快捷鍵：← → 切換圖案 · H 隱藏控件 · Esc 退出。運行中可保持喚醒；結束請手動退出或等待倒計時。',
  refresh_lead: '採樣動畫幀間隔估算 Hz。結果受瀏覽器限幀與省電影響，屬於估算值。',
  refresh_avg: '平均 Hz',
  refresh_low: '1% 低幀 Hz',
  refresh_frames: '採樣幀數',
  refresh_measure: '測 5 秒',
  refresh_note: '這是估算值，不能替代示波器等儀器。',
  motion_lead: '全螢幕移動色條，調節速度觀察殘影與清晰度。',
  motion_speed: '速度',
  touch_lead: '同時按下多個觸點，查看編號、座標與力（若裝置支援）。',
  touch_body: '請在觸控螢幕上使用。每個觸點會顯示編號，抬起後軌跡逐漸消失。',
  touch_active: '目前觸點',
  touch_max: '歷史最多',
  media_lead: '面向前端的即時 matchMedia 面板，複製目前為真的查詢集合。',
  media_copy: '複製為真的查詢',
  safe_lead: '疊加顯示 env(safe-area-inset-*)，方便除錯全面屏邊距。',
  safe_top: '上',
  safe_right: '右',
  safe_bottom: '下',
  safe_left: '左',
  safe_overlay: '顯示疊加',
  inspect_lead: '可選：按項勾選常用檢測。日常使用直接點首頁「開始檢測」即可。',
  inspect_step1: '1. 資訊快檢',
  inspect_step2: '2. 壞點純色',
  inspect_step3: '3. 漏光均勻性',
  inspect_step4: '4. 觸控檢查',
  inspect_pass: '標記通過',
  inspect_fail: '標記失敗',
  inspect_open_solid: '開啟壞點檢測',
  inspect_open_report: '開啟報告',
  status_todo: '待測',
  status_pass: '通過',
  status_fail: '失敗',
  report_lead: '彙總目前顯示指標，複製或下載 JSON。歷史僅存瀏覽器本地。',
  report_generating: '產生中…',
  report_copy: '複製',
  report_download: '下載 JSON',
  settings_lead: '介面語言預設跟隨裝置；也可鎖定語言與主題。資料僅存本機。',
  settings_clear: '清除本地資料',
  settings_clear_note: '將清除語言、主題與草稿報告等本地偏好。',
  faq_how_q: '怎麼用？',
  faq_how_a: '點「開始檢測」→ 進入全螢幕 → 切換顏色看螢幕。發現異常可標記。Esc 或點退出返回。',
  faq_upload_q: '會不會上傳我的螢幕資訊？',
  faq_upload_a: '不會。全部在瀏覽器本地完成，不上傳。',
  faq_checklist_q: '「分步清單」是做什麼的？',
  faq_checklist_a: '給想一項項勾選的人用的可選清單，日常使用直接點「開始檢測」就夠了。',
  marks_label: '標記',
  touches_label: '觸點',
}

const en: Dict = {
  brand: 'Screen Detect',
  nav_home: 'Home',
  nav_inspect: 'Checklist',
  nav_quality: 'Quality',
  nav_motion: 'Motion',
  nav_touch: 'Touch',
  nav_lab: 'Lab',
  nav_report: 'Report',
  nav_settings: 'Settings',
  nav_more: 'More',
  nav_content: 'Knowledge',
  nav_qa: 'Q&A center',
  nav_articles: 'Buying guides',
  solid: 'Dead pixels',
  gradient: 'Gradient / banding',
  grid: 'Grid / geometry',
  uniformity: 'Bleed / uniformity',
  anti_burn_in: 'Anti burn-in / pixel refresh',
  refresh: 'Refresh rate',
  motion_tool: 'Motion blur',
  touch_tool: 'Multi-touch',
  media_lab: 'Media queries',
  safe_area: 'Safe area',
  start_test: 'Start test',
  exit: 'Exit',
  fullscreen: 'Enter fullscreen',
  prev: 'Previous',
  next: 'Next',
  mark: 'Mark',
  hide_hud: 'Hide controls',
  hidden_hint_exit: 'Press Esc to exit fullscreen',
  hidden_hint_next: ' · Click the screen for the next step',
  hidden_hint_fullscreen: ' · Use the button below to enter fullscreen',
  copy: 'Copy summary',
  theme: 'Theme',
  language: 'Language',
  follow_system: 'Follow system',
  light: 'Light',
  dark: 'Dark',
  system: 'System',
  estimated: 'estimated',
  unsupported: 'Unsupported',
  home_title: 'Screen Detect',
  home_lead:
    'Check dead pixels, backlight bleed, and touch issues. One tap to start. Everything stays on your device.',
  home_cta_hint: 'Starts with the dead-pixel test — full-screen black, white, red, green, blue',
  home_more: 'More tests (optional)',
  path_dead_title: 'Dead pixels',
  path_dead_desc: 'Full-screen colors to spot bright or dark defects',
  path_bleed_title: 'Backlight bleed',
  path_bleed_desc: 'Black screen to check glowing corners',
  path_touch_title: 'Touch',
  path_touch_desc: 'Press with multiple fingers to find dead zones',
  metric_css: 'CSS resolution',
  metric_phys: 'Physical pixels (est.)',
  metric_dpr: 'Device pixel ratio',
  metric_viewport: 'Viewport',
  metric_ratio: 'Aspect ratio',
  section_screen: 'Screen & pixels',
  section_prefs: 'System preferences',
  section_tools: 'Popular tests',
  faq_title: 'FAQ',
  qa_view_all: 'View all Q&A',
  qa_dead_home: 'What should I do after finding a dead pixel?',
  qa_bleed_home: 'Does a bright screen edge mean backlight bleed?',
  qa_refresh_home: 'Why does the refresh-rate result fluctuate?',
  privacy_note: 'Runs in the browser. No upload.',
  updated: 'Updated',
  tool_eyebrow: 'Tool',
  footer_note: 'Screen Detect · browser-side only · no upload',
  clear_marks: 'Clear marks',
  solid_lead:
    'Cycle full-screen solid colors to check bright/dark pixels and stains. Press M to mark; Esc to exit.',
  solid_body:
    'Useful for purchase checks and warranty repro. Pixel defects need eyes; marks use CSS pixels.',
  solid_shortcuts: 'Shortcuts: ← → colors · M mark · H hide HUD · Esc exit',
  solid_faq1_q: 'How do I check dead pixels?',
  solid_faq1_a: 'Go full screen and inspect black/white/red/green/blue. Press M to mark issues.',
  solid_faq2_q: 'How do I mark a dead pixel?',
  solid_faq2_a: 'Press M for mark mode, then tap the defect. Coordinates stay listed locally.',
  gradient_lead: 'Horizontal, vertical, and RGB ramps reveal banding; stepped mode helps compare levels.',
  gradient_body: 'Banding often shows on low-bit panels or aggressive compression. Drawn in the browser.',
  grid_lead: 'Full-screen grids and checkers for distortion, blur, and pixel alignment.',
  grid_body: 'Fine grids make scaling blur and uneven sharpness easier to see.',
  grid_size: 'Grid size',
  uniformity_lead: 'In a dim room, check black-field corner glow, then gray patches for uniformity.',
  uniformity_body: 'Best in a dim room. Mild IPS corner glow is common; severity is subjective.',
  anti_burn_in_lead: 'Full-screen moving patterns exercise pixels and reduce uneven aging from static UI. They cannot repair permanent burn-in.',
  anti_burn_in_body: 'Best for OLED / AMOLED while idle. Use moderate brightness and keep the device plugged in. Exit before you leave. This is not a repair tool.',
  anti_burn_in_pattern: 'Pattern',
  anti_burn_in_noise: 'Noise refresh',
  anti_burn_in_stripe: 'Color stripes',
  anti_burn_in_orbit: 'Orbiting blobs',
  anti_burn_in_pulse: 'Soft color cycle',
  anti_burn_in_speed: 'Speed',
  anti_burn_in_duration: 'Duration',
  anti_burn_in_manual: 'Exit manually',
  anti_burn_in_start: 'Start anti burn-in',
  anti_burn_in_learn: 'About burn-in',
  anti_burn_in_tip: 'Shortcuts: ← → change pattern · H hide HUD · Esc exit. Wake Lock may keep the screen on; exit manually or wait for the timer.',
  refresh_lead: 'Samples frame intervals to estimate Hz. Browser caps and power saving affect results.',
  refresh_avg: 'Average Hz',
  refresh_low: '1% low Hz',
  refresh_frames: 'Frames',
  refresh_measure: 'Measure 5s',
  refresh_note: 'This is an estimate, not a hardware instrument reading.',
  motion_lead: 'Moving bars across the screen — adjust speed to judge blur and clarity.',
  motion_speed: 'Speed',
  touch_lead: 'Press multiple contacts to see index, position, and force when available.',
  touch_body: 'Use a touch screen. Each contact shows an index; trails fade after lift.',
  touch_active: 'Active points',
  touch_max: 'Max seen',
  media_lead: 'Live matchMedia panel for front-end debugging. Copy currently true queries.',
  media_copy: 'Copy true queries',
  safe_lead: 'Overlay env(safe-area-inset-*) to debug full-bleed margins.',
  safe_top: 'Top',
  safe_right: 'Right',
  safe_bottom: 'Bottom',
  safe_left: 'Left',
  safe_overlay: 'Overlay',
  inspect_lead: 'Optional checklist. Day to day, just tap Start test on the home page.',
  inspect_step1: '1. Metrics snapshot',
  inspect_step2: '2. Dead pixel solids',
  inspect_step3: '3. Uniformity',
  inspect_step4: '4. Touch check',
  inspect_pass: 'Mark pass',
  inspect_fail: 'Mark fail',
  inspect_open_solid: 'Open solids',
  inspect_open_report: 'Open report',
  status_todo: 'todo',
  status_pass: 'pass',
  status_fail: 'fail',
  report_lead: 'Summarize display metrics. Copy or download JSON. History stays local.',
  report_generating: 'Generating…',
  report_copy: 'Copy',
  report_download: 'Download JSON',
  settings_lead: 'Language follows the device by default. Lock language and theme anytime. Local only.',
  settings_clear: 'Clear local data',
  settings_clear_note: 'Removes locale, theme, and draft report preferences from localStorage.',
  faq_how_q: 'How do I use it?',
  faq_how_a: 'Tap Start test → go full screen → cycle colors. Mark issues. Esc or Exit to leave.',
  faq_upload_q: 'Do you upload my screen data?',
  faq_upload_a: 'No. Everything runs locally in the browser.',
  faq_checklist_q: 'What is the checklist for?',
  faq_checklist_a: 'An optional step list. For everyday use, Start test is enough.',
  marks_label: 'marks',
  touches_label: 'touches',
}

const ja: Dict = {
  brand: 'Screen Detect',
  nav_home: 'ホーム',
  nav_inspect: 'チェックリスト',
  nav_quality: '画質',
  nav_motion: '動き',
  nav_touch: 'タッチ',
  nav_lab: 'ラボ',
  nav_report: 'レポート',
  nav_settings: '設定',
  nav_more: 'その他',
  nav_content: 'ナレッジ',
  nav_qa: 'Q&A',
  nav_articles: '購入ガイド',
  solid: 'ドット抜け / 単色',
  gradient: '階調 / グラデ',
  grid: 'グリッド',
  uniformity: '光漏れ / ムラ',
  anti_burn_in: '焼き付き防止 / ピクセル更新',
  refresh: 'リフレッシュレート',
  motion_tool: '残像 / モーション',
  touch_tool: 'マルチタッチ',
  media_lab: 'メディアクエリ',
  safe_area: 'セーフエリア',
  start_test: 'テスト開始',
  exit: '終了',
  fullscreen: '全画面表示',
  prev: '前へ',
  next: '次へ',
  mark: 'マーク',
  hide_hud: 'HUDを隠す',
  hidden_hint_exit: 'Escキーで全画面表示を終了',
  hidden_hint_next: ' · 画面をクリックして次へ',
  hidden_hint_fullscreen: ' · 下のボタンで全画面表示',
  copy: '要約をコピー',
  theme: 'テーマ',
  language: '言語',
  follow_system: 'システムに合わせる',
  light: 'ライト',
  dark: 'ダーク',
  system: 'システム',
  estimated: '推定',
  unsupported: '非対応',
  home_title: 'Screen Detect',
  home_lead: 'ドット抜け・光漏れ・タッチ不良をすぐ確認。ワンタップで開始。データは端末内だけ。',
  home_cta_hint: 'よく使うドット抜けテストから開始（黒白赤緑青）',
  home_more: 'その他のテスト（任意）',
  path_dead_title: 'ドット抜け',
  path_dead_desc: '全画面の単色で不良画素を確認',
  path_bleed_title: '光漏れ',
  path_bleed_desc: '黒画面で四隅の白浮きを確認',
  path_touch_title: 'タッチ',
  path_touch_desc: '複数指で反応しない箇所を確認',
  metric_css: 'CSS解像度',
  metric_phys: '物理ピクセル（推定）',
  metric_dpr: 'デバイス画素比',
  metric_viewport: 'ビューポート',
  metric_ratio: 'アスペクト比',
  section_screen: '画面と画素',
  section_prefs: 'システム設定',
  section_tools: 'よく使うテスト',
  faq_title: 'よくある質問',
  qa_view_all: 'Q&Aをすべて見る',
  qa_dead_home: 'ドット抜けを見つけたらどうすればよい？',
  qa_bleed_home: '画面端の白浮きは光漏れ？',
  qa_refresh_home: 'リフレッシュレートの結果が変動する理由は？',
  privacy_note: 'ブラウザ内完結・送信なし',
  updated: '更新',
  tool_eyebrow: 'ツール',
  footer_note: 'Screen Detect · ブラウザ内のみ · 送信なし',
  clear_marks: 'マークを消去',
  solid_lead:
    '全画面の単色で輝点・黒点・色ムラを確認。M でマーク、Esc で終了。',
  solid_body: '購入時チェックや再現用に。物理画素は目視確認。座標は CSS ピクセル基準。',
  solid_shortcuts: 'ショートカット：← → 色切替 · M マーク · H HUD隠す · Esc 終了',
  solid_faq1_q: 'ドット抜けの見方は？',
  solid_faq1_a: '全画面で黒白赤緑青を見て、異常があれば M でマーク。',
  solid_faq2_q: 'マークの付け方は？',
  solid_faq2_a: 'M でマークモードにし、不良箇所をタップ。座標は端末内に表示。',
  gradient_lead: '水平・垂直・RGB のグラデで階調飛びを確認。階段モードで段階比較。',
  gradient_body: '低ビットパネルや強い圧縮でバンディングが出やすい。ブラウザ描画です。',
  grid_lead: '全画面グリッドと市松で歪み・ぼけ・画素ずれを確認。',
  grid_body: '細かいグリッドほどスケールぼけやムラが見えやすい。',
  grid_size: 'グリッドサイズ',
  uniformity_lead: '暗所で黒画面の四隅光漏れを確認し、グレーでムラを比較。',
  uniformity_body: '暗い部屋で見るのがおすすめ。IPS の四隅微光はよくあります。',
  anti_burn_in_lead: '全画面の動くパターンで画素を動かし、固定 UI による偏った劣化リスクを下げます。既にできた焼き付きは直せません。',
  anti_burn_in_body: 'OLED / AMOLED の待機時向け。明るさは中低め、できれば充電しながら。離席前に終了してください。修理ツールではありません。',
  anti_burn_in_pattern: 'パターン',
  anti_burn_in_noise: 'ノイズ更新',
  anti_burn_in_stripe: 'カラー帯',
  anti_burn_in_orbit: '光斑移動',
  anti_burn_in_pulse: '柔らかい色循環',
  anti_burn_in_speed: '速度',
  anti_burn_in_duration: '時間',
  anti_burn_in_manual: '手動で終了',
  anti_burn_in_start: '焼き付き防止を開始',
  anti_burn_in_learn: '焼き付きについて',
  anti_burn_in_tip: 'ショートカット：← → パターン切替 · H HUD 隠す · Esc 終了。Wake Lock で画面維持可。手動終了かタイマー待ち。',
  refresh_lead: 'フレーム間隔から Hz を推定。ブラウザ制限や省電力の影響を受けます。',
  refresh_avg: '平均 Hz',
  refresh_low: '1% Low Hz',
  refresh_frames: 'フレーム数',
  refresh_measure: '5秒計測',
  refresh_note: '推定値であり、計測器の代替ではありません。',
  motion_lead: '移動する帯で残像と鮮明さを確認。速度を調整できます。',
  motion_speed: '速度',
  touch_lead: '複数点を同時に押し、番号・座標・圧力（対応時）を確認。',
  touch_body: 'タッチ画面で使用。各接点に番号表示、離すと軌跡が消えます。',
  touch_active: '現在の接点',
  touch_max: '最大同時',
  media_lead: 'matchMedia のライブパネル。真のクエリをコピーできます。',
  media_copy: '真のクエリをコピー',
  safe_lead: 'env(safe-area-inset-*) を重ねて表示し、余白を確認。',
  safe_top: '上',
  safe_right: '右',
  safe_bottom: '下',
  safe_left: '左',
  safe_overlay: 'オーバーレイ',
  inspect_lead: '任意のチェックリスト。普段はホームの「テスト開始」で十分です。',
  inspect_step1: '1. 情報スナップ',
  inspect_step2: '2. ドット抜け',
  inspect_step3: '3. 光漏れ',
  inspect_step4: '4. タッチ確認',
  inspect_pass: '合格にする',
  inspect_fail: '不合格にする',
  inspect_open_solid: '単色テストへ',
  inspect_open_report: 'レポートへ',
  status_todo: '未',
  status_pass: '合格',
  status_fail: '不合格',
  report_lead: '表示指標をまとめて JSON をコピー／ダウンロード。履歴は端末内のみ。',
  report_generating: '生成中…',
  report_copy: 'コピー',
  report_download: 'JSONを保存',
  settings_lead: '言語は端末に追従。固定も可能。データは端末内のみ。',
  settings_clear: 'ローカルデータを消去',
  settings_clear_note: '言語・テーマ・下書きレポート設定を localStorage から削除します。',
  faq_how_q: '使い方は？',
  faq_how_a: '「テスト開始」→ 全画面 → 色を切替。異常はマーク。Esc か終了で戻る。',
  faq_upload_q: '画面データは送信されますか？',
  faq_upload_a: 'いいえ。すべてブラウザ内で完結します。',
  faq_checklist_q: 'チェックリストとは？',
  faq_checklist_a: '任意の手順リストです。普段は「テスト開始」だけで十分。',
  marks_label: 'マーク',
  touches_label: 'タッチ',
}

export const dictionaries: Record<Locale, Dict> = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  en,
  ja,
}

export function t(locale: Locale, key: string): string {
  return dictionaries[locale][key] ?? dictionaries.en[key] ?? key
}
